<template>
	<div class="quick">
		<h4>快捷发布</h4>
		<div class="main">
			<div v-for="item in classList">
				<router-link :to="{path:'Release', query:{id: item.id}}">
					<img :src="item.image | handleUrl" alt="">
				</router-link>
				<span>{{item.title}}</span>
			</div>
		</div>
		<div class="footer">
			<img src="../../assets/add.png" alt="" @click="back()">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				classList: []
			}
		},
		created() {
			//加载分类信息
			this.$axios.post(baseUrl + '/mobile/Fta/ftaCategory').then((res)=> {
				if (res.data.code == 2) {
					this.classList = res.data.data;
				}
			}).catch((err)=> {
				console.log(err);
			});
		}
	}
</script>

<style scoped>
	.quick {
		background: #fff;
		height: 100%;
	}

	.quick h4 {
		text-align: left;
		margin: 0;
		padding: 1.5rem 0 0 0.7rem;
	}

	.quick .main {
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 3rem;
		margin-top: 1rem;
	}

	.quick .main div {
		width: 25%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		font-size: 0.75rem;
		margin-bottom: 1rem;
	}

	.quick .main div img {
		width: 4rem;
		height: 4rem;
		margin-bottom: 0.5rem;
		border-radius: 0.5rem;
		/* border: 1px solid #f0eff5; */
	}

	.quick .footer {
		position: fixed;
		bottom: 1rem;
		right: 0;
		left: 0;
		margin: auto;
	}

	.quick .footer img {
		width: 3rem;
		height: 3rem;
		border-radius: 50%;
		transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		-webkit-transform: rotate(45deg);
	}
</style>



// WEBPACK FOOTER //
// src/components/home/quick.vue